import { render, staticRenderFns } from "./AudioPlayerBar.vue?vue&type=template&id=05b46a4a&scoped=true"
import script from "./AudioPlayerBar.vue?vue&type=script&lang=js"
export * from "./AudioPlayerBar.vue?vue&type=script&lang=js"
import style0 from "./AudioPlayerBar.vue?vue&type=style&index=0&id=05b46a4a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05b46a4a",
  null
  
)

export default component.exports